import Papa, { ParseResult } from 'papaparse';

export interface SectorIndustry {
  sector: string;
  industry: string;
}

export const loadSectorIndustries = async (): Promise<SectorIndustry[]> => {
  try {
    const response = await fetch('/src/assets/data/SectorIndustries.csv');
    const csvText = await response.text();
    
    return new Promise<SectorIndustry[]>((resolve, reject) => {
      Papa.parse<SectorIndustry>(csvText, {
        header: true,
        skipEmptyLines: true,
        complete: (results: ParseResult<SectorIndustry>) => {
          resolve(results.data);
        },
        error: (error: Error) => {
          console.error('CSV parsing error:', error);
          reject(error);
        }
      });
    });
  } catch (error) {
    console.error('Error loading sector/industry data:', error);
    throw error;
  }
};

export const getUniqueSectors = (data: SectorIndustry[]): string[] => {
  return Array.from(new Set(data.map(item => item.sector))).sort();
};

export const getIndustriesForSector = (data: SectorIndustry[], sector: string): string[] => {
  return data
    .filter(item => item.sector === sector)
    .map(item => item.industry)
    .sort();
};
